import pdfMake from 'pdfmake/build/pdfmake';

// Простой способ инициализации шрифтов без ошибок
let fontsLoaded = false;

const initializeFonts = async () => {
  if (fontsLoaded) return;
  
  try {
    const pdfFonts = await import('pdfmake/build/vfs_fonts');
    pdfMake.vfs = pdfFonts.default?.pdfMake?.vfs || pdfFonts.default?.vfs || pdfFonts.pdfMake?.vfs || pdfFonts.vfs;
    fontsLoaded = true;
    console.log('✅ Шрифты pdfMake загружены');
  } catch (error) {
    console.warn('⚠️ Ошибка загрузки шрифтов pdfMake:', error);
    // Продолжаем без кастомных шрифтов - встроенные будут использоваться
  }
};

// Создание PDF документа с полной поддержкой кириллицы
function createQuotePDF(data) {
  const {
    shopData,
    productData,
    dimensionsData,
    glassData,
    hardwareData,
    calculationResult,
    finalPrice
  } = data;

  // Определяем документ
  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [40, 60, 40, 60],
    
    content: [
      // Заголовок
      {
        text: 'КОММЕРЧЕСКОЕ ПРЕДЛОЖЕНИЕ',
        style: 'header',
        alignment: 'center',
        margin: [0, 0, 0, 20]
      },

      // Информация о магазине
      ...(shopData ? [
        {
          text: shopData.name || 'Магазин',
          style: 'shopName',
          margin: [0, 0, 0, 5]
        },
        ...(shopData.address ? [{
          text: shopData.address,
          style: 'shopInfo',
          margin: [0, 0, 0, 3]
        }] : []),
        ...(shopData.contact_info?.['тел'] ? [{
          text: `Телефон: ${shopData.contact_info['тел']}`,
          style: 'shopInfo',
          margin: [0, 0, 0, 3]
        }] : []),
        ...(shopData.contact_info?.email ? [{
          text: `Email: ${shopData.contact_info.email}`,
          style: 'shopInfo',
          margin: [0, 0, 0, 3]
        }] : []),
        {
          canvas: [{ type: 'line', x1: 0, y1: 5, x2: 515, y2: 5, lineWidth: 1, lineColor: '#cccccc' }],
          margin: [0, 10, 0, 20]
        }
      ] : []),

      // Информация о продукте
      ...(productData ? [
        {
          text: 'МОДЕЛЬ ДУШЕВОЙ КАБИНЫ',
          style: 'sectionTitle',
          margin: [0, 10, 0, 8]
        },
        {
          text: productData.name || 'Не указано',
          style: 'productName',
          margin: [10, 0, 0, 5]
        },
        ...(productData.description ? [{
          text: productData.description,
          style: 'description',
          margin: [10, 0, 0, 15]
        }] : [])
      ] : []),

      // Размеры кабины
      ...(dimensionsData && Object.keys(dimensionsData).length > 0 ? [
        {
          text: 'РАЗМЕРЫ КАБИНЫ',
          style: 'sectionTitle',
          margin: [0, 10, 0, 8]
        },
        {
          table: {
            widths: ['*', '*'],
            body: Object.entries(dimensionsData).map(([key, dimension]) => [
              { text: `${dimension.label}:`, style: 'dimensionLabel' },
              { text: `${dimension.value} мм`, style: 'dimensionValue' }
            ])
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 10,
            paddingRight: () => 10,
            paddingTop: () => 3,
            paddingBottom: () => 3
          },
          margin: [10, 0, 0, 15]
        }
      ] : []),

      // Информация о стекле
      ...(glassData ? [
        {
          text: 'ТИП СТЕКЛА',
          style: 'sectionTitle',
          margin: [0, 10, 0, 8]
        },
        {
          table: {
            widths: ['*'],
            body: [
              [{ 
                stack: [
                  { text: glassData.name, style: 'productName', margin: [0, 0, 0, 5] },
                  ...(glassData.description ? [{ text: glassData.description, style: 'description', margin: [0, 0, 0, 3] }] : []),
                  ...(glassData.thickness ? [{ text: `Толщина: ${glassData.thickness} мм`, style: 'description', margin: [0, 0, 0, 3] }] : []),
                  ...(calculationResult?.calculation?.glass_area ? [{ text: `Площадь стекла: ${calculationResult.calculation.glass_area} м²`, style: 'description' }] : [])
                ],
                fillColor: '#f8f9fa',
                margin: [5, 5, 5, 5]
              }]
            ]
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#e9ecef',
            vLineColor: () => '#e9ecef'
          },
          margin: [10, 0, 0, 15]
        }
      ] : []),

      // Набор фурнитуры
      ...(hardwareData ? [
        {
          text: 'ФУРНИТУРА',
          style: 'sectionTitle',
          margin: [0, 10, 0, 8]
        },
        {
          text: hardwareData.name,
          style: 'productName',
          margin: [10, 0, 0, 5]
        },
        ...(hardwareData.description ? [{
          text: hardwareData.description,
          style: 'description',
          margin: [10, 0, 0, 10]
        }] : []),
        
        ...(hardwareData.hardware_items && hardwareData.hardware_items.length > 0 ? [
          {
            table: {
              widths: ['*', 80],
              headerRows: 1,
              body: [
                [
                  { text: 'Наименование', style: 'tableHeader' },
                  { text: 'Количество', style: 'tableHeader', alignment: 'center' }
                ],
                ...hardwareData.hardware_items.map(item => [
                  { 
                    text: item.hardware_details?.display_name || 
                          item.hardware_details?.name || 
                          'Не указано', 
                    style: 'tableCell' 
                  },
                  { 
                    text: `${item.quantity} шт.`, 
                    style: 'tableCell', 
                    alignment: 'center' 
                  }
                ])
              ]
            },
            layout: {
              hLineWidth: () => 1,
              vLineWidth: () => 1,
              hLineColor: () => '#dddddd',
              vLineColor: () => '#dddddd'
            },
            margin: [10, 0, 0, 15]
          }
        ] : [])
      ] : []),

      // Итоговая стоимость
      ...(finalPrice ? [
        {
          table: {
            widths: ['*'],
            body: [
              [{
                stack: [
                  { text: 'Итоговая стоимость:', style: 'priceLabel', alignment: 'center', margin: [0, 0, 0, 10] },
                  { text: `${finalPrice.toLocaleString('ru-RU')} ₽`, style: 'finalPrice', alignment: 'center' }
                ],
                fillColor: '#f8f9fa',
                margin: [15, 15, 15, 15]
              }]
            ]
          },
          layout: {
            hLineWidth: () => 2,
            vLineWidth: () => 2,
            hLineColor: () => '#28a745',
            vLineColor: () => '#28a745'
          },
          margin: [50, 20, 50, 20]
        }
      ] : []),

      // Подвал
      {
        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 515, y2: 5, lineWidth: 1, lineColor: '#cccccc' }],
        margin: [0, 30, 0, 15]
      },
      {
        text: 'Спасибо за обращение! Будем рады сотрудничеству.',
        style: 'footer',
        alignment: 'center',
        margin: [0, 0, 0, 5]
      },
      ...(calculationResult?.timestamp ? [{
        text: `Дата расчета: ${new Date(calculationResult.timestamp).toLocaleString('ru-RU')}`,
        style: 'footerDate',
        alignment: 'center'
      }] : [])
    ],

    styles: {
      header: {
        fontSize: 18,
        bold: true,
        color: '#333333'
      },
      shopName: {
        fontSize: 14,
        bold: true,
        color: '#333333'
      },
      shopInfo: {
        fontSize: 10,
        color: '#666666'
      },
      sectionTitle: {
        fontSize: 12,
        bold: true,
        color: '#444444',
        background: '#f5f5f5'
      },
      productName: {
        fontSize: 12,
        bold: true,
        color: '#333333'
      },
      description: {
        fontSize: 10,
        color: '#666666'
      },
      dimensionLabel: {
        fontSize: 10,
        bold: true
      },
      dimensionValue: {
        fontSize: 10
      },
      tableHeader: {
        fontSize: 10,
        bold: true,
        fillColor: '#f5f5f5'
      },
      tableCell: {
        fontSize: 9
      },
      priceLabel: {
        fontSize: 12,
        color: '#666666'
      },
      finalPrice: {
        fontSize: 20,
        bold: true,
        color: '#28a745'
      },
      footer: {
        fontSize: 10,
        color: '#888888'
      },
      footerDate: {
        fontSize: 8,
        color: '#aaaaaa'
      }
    },

    defaultStyle: {
      font: 'Roboto'
    }
  };

  return docDefinition;
}

// Основная функция для генерации PDF
export async function generateQuotePDF(data) {
  try {
    console.log('🎯 Генерируем PDF с pdfMake (полная поддержка кириллицы)...');
    
    // Загружаем шрифты перед созданием PDF
    await initializeFonts();
    
    const docDefinition = createQuotePDF(data);
    const pdfDoc = pdfMake.createPdf(docDefinition);
    
    console.log('✅ PDF успешно создан с pdfMake');
    
    return {
      download: (filename) => {
        pdfDoc.download(filename);
      },
      getBlob: () => {
        return new Promise((resolve) => {
          pdfDoc.getBlob((blob) => {
            resolve(blob);
          });
        });
      },
      getPdf: () => pdfDoc
    };
  } catch (error) {
    console.error('❌ Ошибка создания PDF:', error);
    throw error;
  }
}

export default { generateQuotePDF }; 